import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
var basePath = 'numberManagement';
var crud = createCrud(basePath);

/* Default queries */
export var useNumberManagementCount = crud.makeCount();
export var useNumberManagementById = crud.makeFindById();
export var useNumberManagementByIds = crud.makeFindByIds();
export var useNumberManagementMany = crud.makeFindMany();
export var useNumberManagementOne = crud.makeFindOne();
export var useNumberManagementPagination = crud.makePagination();

/* Default mutations */
// @ts-expect-error TODO: fix this
export var useNumberManagementCreateOne = crud.makeCreateOne();
export var useNumberManagementUpdateOne = crud.makeUpdateOne();
export var useNumberManagementRemoveById = crud.makeRemoveById();

// Custom mutations
export function useNumberManagementTransferNumber() {
  var axiosService = useAxiosClient();
  var mutateFn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var numberId, targetRootAccount, _yield$axiosService$p, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            numberId = _ref.numberId, targetRootAccount = _ref.targetRootAccount;
            _context.next = 3;
            return axiosService.post("v2/".concat(basePath, "/").concat(numberId, "/transfer"), {
              targetRootAccount: targetRootAccount
            });
          case 3:
            _yield$axiosService$p = _context.sent;
            data = _yield$axiosService$p.data;
            return _context.abrupt("return", data);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function mutateFn(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var mutation = useMutation([basePath], mutateFn);
  return mutation;
}
export var useNumberManagementHostingSendLOA = function useNumberManagementHostingSendLOA() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var id, email, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            id = _ref3.id, email = _ref3.email;
            _context2.next = 3;
            return axiosClient.post("".concat(basePath, "/").concat(id, "/hosting/sendLOA"), {
              email: email
            });
          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function mutationFn(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  return useMutation([basePath], mutationFn);
};
export var useNumberManagementHostNumberVerificationCall = function useNumberManagementHostNumberVerificationCall() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var id, _ref5$extension, extension, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            id = _ref5.id, _ref5$extension = _ref5.extension, extension = _ref5$extension === void 0 ? '' : _ref5$extension;
            _context3.next = 3;
            return axiosClient.post("".concat(basePath, "/").concat(id, "/hosting/ownership"), {
              extension: extension
            });
          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function mutationFn(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  return useMutation([], mutationFn);
};
export var useNumberManagementHostNumberVerifyCode = function useNumberManagementHostNumberVerifyCode() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
      var id, code, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            id = _ref7.id, code = _ref7.code;
            _context4.next = 3;
            return axiosClient.post("".concat(basePath, "/").concat(id, "/hosting/verification"), {
              code: code
            });
          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function mutationFn(_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  return useMutation([basePath], mutationFn);
};
export var useNumberManagementHostNumber = function useNumberManagementHostNumber() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(number) {
      var response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axiosClient.post("".concat(basePath, "/hosting"), {
              number: number
            });
          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function mutationFn(_x5) {
      return _ref9.apply(this, arguments);
    };
  }();
  return useMutation([basePath], mutationFn);
};